module["exports"] = [" s/n.", ", #", ", ##", " #", " ##", " ###", " ####"];